"use strict";

/**
 * @ngdoc directive
 * @name diceApp.directive:toggleInput
 * @description
 * The toggleInput directive.
 */
angular.module("diceApp").component("toggleInput", {
  templateUrl: "es6/base/forms/inputs/toggle.input.html",
  bindings: {
    id: "@?",
    name: "@?",
    ngDisabled: "<?",
    classes: "@?",
    label: "@?"
  },
  require: {
    ngModel: "ngModel"
  },
  controllerAs: "toggleInputController",
  controller: function ($scope) {
    const toggleInputController = this;

    toggleInputController.$onInit = function () {
      if (angular.isUndefined(toggleInputController.ngDisabled)) {
        toggleInputController.ngDisabled = false;
      }

      $scope.$watch("toggleInputController.ngModel.$modelValue", function () {
        toggleInputController.value = toggleInputController.ngModel.$modelValue;
      });
    };

    toggleInputController.onClick = function (event) {
      // Clicks on the checkbox itself (including Space) are already handled natively.
      if (event.target.type === "checkbox") {
        return;
      }

      if (toggleInputController.ngDisabled !== true) {
        toggleInputController.value = toggleInputController.value !== true;
        toggleInputController.onChange();
      }
    };

    toggleInputController.onChange = function () {
      toggleInputController.ngModel.$setViewValue(toggleInputController.value);
    };
  }
});
